import { GUEST_PROFILE_GUID } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { useQuery } from '@tanstack/react-query';
import { container } from '../../DataDomain';
import { IBookmarkService } from '../../application/services/BookmarkService';

interface IUseGetDetailedBookMarksQuery {
    apiKey: string;
    profileGuid: string | undefined;
    authToken: string;
    identityToken: string;
    country: string;
    device: string;
    programType: string;
}

export const useGetBookMarksQuery = (params: IUseGetDetailedBookMarksQuery) =>
    useQuery({
        queryKey: ['profiles', 'bookmarks', params.profileGuid],
        staleTime: 60 * 1000,
        enabled: Boolean(params.profileGuid),
        refetchInterval: 60 * 1000,
        queryFn: async () => {
            if (!params.profileGuid) {
                throw new Error('profileGuid is required to fetch bookmarks');
            }
            if (params.profileGuid === GUEST_PROFILE_GUID) {
                return [];
            }
            const bookmarkService = container.resolve<IBookmarkService>(DI.SERVICES.IBookmarkService);
            const response = await bookmarkService.getBookmark(
                params.apiKey,
                params.profileGuid,
                params.authToken,
                params.identityToken
            );
            return response.data;
        },
        retry: 3,
        refetchOnWindowFocus: false,
    });
